import { Controller } from "@hotwired/stimulus";

// Auto-calculation for income form: breakdown sums, Total cobrado efectivo = cierre - apertura,
// Ingreso total efectivo = cobrado + ajuste efectivo, Ingreso total tarjeta = sum_of_tpv + ajuste tarjeta,
// Ingreso total BAR = efectivo + tarjeta.
export default class extends Controller {
    static targets = [
        "openingBreakdown",
        "closingBreakdown",
        "sumOpening",
        "sumClosing",
        "cashAdjustment",
        "cardAdjustment",
        "sumOfTpv",
        "cashCobradoDisplay",
        "cashTotalDisplay",
        "cardDisplay",
        "totalDisplay"
    ];

    connect() {
        this.onChange = this.recalculate.bind(this);
        this.openingBreakdownTargets.forEach((el) => el.addEventListener("input", this.onChange));
        this.closingBreakdownTargets.forEach((el) => el.addEventListener("input", this.onChange));
        this.recalculate();
    }

    disconnect() {
        this.openingBreakdownTargets.forEach((el) => el.removeEventListener("input", this.onChange));
        this.closingBreakdownTargets.forEach((el) => el.removeEventListener("input", this.onChange));
    }

    sumBreakdown(targets) {
        if (!targets || targets.length === 0) return 0;
        return targets.reduce((sum, el) => {
            const qty = this.parseNumber(el.value);
            const denom = parseFloat(el.getAttribute("data-denomination") || "0", 10);
            return sum + (qty || 0) * denom;
        }, 0);
    }

    recalculate() {
        const opening = this.sumBreakdown(this.openingBreakdownTargets);
        const closing = this.sumBreakdown(this.closingBreakdownTargets);
        const cashAdj = this.parseNumber(this.cashAdjustmentTargets[0]?.value) || 0;
        const cardAdj = this.parseNumber(this.cardAdjustmentTargets[0]?.value) || 0;
        const sumTpv = this.parseNumber(this.sumOfTpvTargets[0]?.value) || 0;

        const cashCobrado = closing - opening;
        const cashTotal = cashCobrado - cashAdj;
        const cardTotal = sumTpv - cardAdj;
        const total = cashTotal + cardTotal;

        this.updateSum(this.sumOpeningTargets[0], opening);
        this.updateSum(this.sumClosingTargets[0], closing);
        this.updateDisplay(this.cashCobradoDisplayTargets[0], cashCobrado);
        this.updateDisplay(this.cashTotalDisplayTargets[0], cashTotal);
        this.updateDisplay(this.cardDisplayTargets[0], cardTotal);
        this.updateDisplay(this.totalDisplayTargets[0], total);
    }

    updateSum(el, value) {
        if (!el) return;
        el.textContent = isFinite(value) ? `${value.toFixed(2)} €` : "0.00 €";
    }

    updateDisplay(el, value) {
        if (!el) return;
        el.textContent = isFinite(value) ? `${value.toFixed(2)} €` : "0.00 €";
    }

    parseNumber(val) {
        if (val == null || String(val).trim() === "") return null;
        const s = String(val).replace(/\s|\u00A0/g, "").replace(/,/g, ".");
        const n = Number(s);
        return isNaN(n) ? null : n;
    }
}
